import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';

import { configs } from '@constants/configs/configs';
import { ENROLLMENT_HISTORY_ACTION_TYPES } from '@constants/actionTypes/enrollmentHistoryTypes';

export const setEnrollmentHistoryData = ({ data }) => ({
    type: ENROLLMENT_HISTORY_ACTION_TYPES.GET_ENROLLMENT_HISTORY,
    payload: data,
});

export const setEnrollmentHistoryError = ()=>({
    type: ENROLLMENT_HISTORY_ACTION_TYPES.GET_ENROLLMENT_HISTORY_ERROR,
    payload: 'Cannot get enrollment history',
});

export const setHistoricalEnrollmentsData = ({ data }) => ({
    type: ENROLLMENT_HISTORY_ACTION_TYPES.GET_HISTORICAL_ENROLLMENTS,
    payload: data,
});

export const setHistoricalEnrollmentsError = () => ({
    type: ENROLLMENT_HISTORY_ACTION_TYPES.GET_HISTORICAL_ENROLLMENTS_ERROR,
    payload: 'Cannot get historical enrollments',
});

const actions = { setError, startSpinner, stopSpinner };

export const getEnRollmentHistory = (coverageYear, language) => async dispatch => {
    const url = configs.endpoints.GET_ENROLLMENT_HISTORY.processReplacements({ coverageYear, timestamp: new Date().getTime(), language });
    const data = await API.getData( url, dispatch, actions );

    if (data) {
        dispatch(setEnrollmentHistoryData({ data }));
    } else {
        dispatch(setEnrollmentHistoryError());
    }
};

export const getHistoricalEnrollments = (coverageYear, language) => async dispatch => {
    const url = configs.endpoints.HISTORICAL_ENROLLMENTS.processReplacements({ coverageYear, language });
    const response = await API.getData(url, dispatch, actions);

    if (response?.data) {
        dispatch(setHistoricalEnrollmentsData({ data: response.data }));
    } else {
        dispatch(setHistoricalEnrollmentsError());
    }
};
